import styled, { css } from 'styled-components';

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
  `}
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ActionsRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      gap: 24px;
      margin-top: auto;
    }
  `}
`;
